module.exports = __webpack_public_path__ + "img/john-babtist.f964a02f.png";